import React from 'react'
import { useDispatch } from 'react-redux'
import isObject from 'lodash/isObject'
import isArray from 'lodash/isArray'
import Button from 'muicss/lib/react/button'
import { dismissModal as dismissModalAction } from 'services/modal/redux/actions'
import { UNHANDLED_ERROR } from 'services/error'

import './index.scss'

const getWithMeta = ({
  detail,
  status,
  statusCode,
  meta,
  message,
}) => meta.map((item, index) => (
  <li key={`meta-${index}`}>
    <strong>Status Code: </strong>{status || statusCode} <br />
    <strong>Message: </strong>{item || message || detail || UNHANDLED_ERROR}
  </li>
))

const getSingleError = (error) => {
  const {
    detail,
    status,
    statusCode,
    meta,
    message,
  } = error

  if (isArray(meta)) {
    return getWithMeta(error)
  }

  return (
    <li>
      <strong>Status Code: </strong>{status || statusCode} <br />
      <strong>Message: </strong>{message || detail || UNHANDLED_ERROR}
    </li>
  )
}

const ErrorRow = ({ error }) => {
  if (isArray(error)) {
    return error.map((err) => getSingleError(err))
  }

  if (isObject(error)) {
    return getSingleError(error)
  }

  return <li>{error}</li>
}

const ErrorsModal = ({ errors = [] }) => {
  const dispatch = useDispatch()

  return (
    <>
      <h2>Something went wrong</h2>
      <div className="modal-errors__container">
        <ul>
          {errors.map((error, index) => (
            <ErrorRow key={index} error={error} />
          ))}
        </ul>
      </div>
      <Button
        className="mui--pull-right"
        type="button"
        onClick={() => dispatch(dismissModalAction())}
      >
        Ok
      </Button>
    </>
  )
}

export default ErrorsModal
